import type { Features, Locale } from '@/hooks/featureFlagHooks';
import { getLocaleData } from '@/selectors/localeSelectors';
import {
  getCenturionNetworkFlags,
  getCulinaryCollectiveFlags,
} from '@/selectors/configSelectors';

export const convertStringFlagToList = <T extends string = string>(
  featureFlagsString: T
): T[] => {
  if (!featureFlagsString) {
    return [] as T[];
  }

  return featureFlagsString
    .split(',')
    .map((flag) => flag.trim())
    .filter(Boolean)
    .map((flag) => flag as T);
};

export const canViewTCL = ({
  state,
  feature,
}: {
  state: object;
  feature: Features;
}) => {
  const locale: Locale = getLocaleData(state).locale.toLowerCase();
  const centurionNetworkFlags = getCenturionNetworkFlags(state);
  const culinaryCollectiveFlags = getCulinaryCollectiveFlags(state);

  const featureFlags = {
    CULINARY_COLLECTIVE_PAGE: new Set<Locale>(
      convertStringFlagToList<Locale>(culinaryCollectiveFlags)
    ),
    CENTURION_NETWORK_PAGE: new Set<Locale>(
      convertStringFlagToList<Locale>(centurionNetworkFlags)
    ),
  };

  return featureFlags[feature].has(locale);
};
